export default {"src":"/_next/static/media/school3.da6121e5.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};